export default {
	FEATURE: {
		userSettingsChangePwd: true,
		userAvatar: false,
		userCover: false
	},
	CONFIG: {}
}